import { NeoModel, ModelBase, Rules, Attributes } from "@singularsystems/neo-core";
import { TimeZoneFormat } from "@singularsystems/neo-core/dist/Misc";

@NeoModel
export default class StaticExportFileSpecLookup extends ModelBase {

    public staticExportFileSpecId: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public reportSpecName: string = "";

    @Rules.Required()
    @Rules.StringLength(200)
    public reportProcedureName: string = "";

    @Rules.Required()
    @Rules.StringLength(10)
    public format: string = "";

    public columnCount: number = 0;

    public isActiveInd: boolean = false;

    public latestVersionOfExportFileSpecId: number = 0;

    public fileSpecPropertiesConcatenated: string | null = null;

    public isCreatedFromPreviousVersion: boolean = false;

}